<template>
    <div class="fidelior-title">
        <h1>
            {{text}}
        </h1>
    </div>
</template>

<script>
export default {
    props: ['text']
}
</script>